<p>
  The entered name will be converted to lowercase when the input field loses focus (or when <kbd>enter</kbd> is pressed).
</p>
<p class="problem">
  Clicking outside the input field or pressing <kbd>enter</kbd> should always trigger the conversion.<br>
  Sometimes it does not. Then the unconverted name will be added to the list.
</p>
